import { c as _c } from "react/compiler-runtime";
import type { Entry, UnresolvedLink } from "contentful";
import type { CtaExposures } from "@/components/custom/CtaButton/CTAButtonPersonalized";
import { Card, CardContent } from "@/components/ui/card";
import { getEntryOfContentType } from "@/lib/contentful/guards";
import type { TypeButton, TypeButtonSkeleton, TypeExternalButton, TypeExternalButtonSkeleton, TypeImage, TypeProse, TypeProseSkeleton } from "@/types/contentful/generated";
import { ContentfulHelper } from "@/utils/ContentfulHelper";
import { EditorialSide } from "./EditorialSide";
type ButtonEntry = TypeButton<undefined, string> | TypeExternalButton<undefined, string>;
type ProseEntry = TypeProse<undefined, string>;
type ProseLike = Entry<TypeProseSkeleton, undefined, string> | UnresolvedLink<"Entry">;
type CtaLike = Entry<TypeButtonSkeleton | TypeExternalButtonSkeleton, undefined, string> | UnresolvedLink<"Entry">;
interface Props {
  alignment: "Image left" | "Image right";
  heading: string;
  subheading: string;
  paragraphText: ProseLike;
  image: TypeImage<undefined, string>;
  cta?: CtaLike;
  ctaExposures?: CtaExposures;
}
export default function Editorial(t0) {
  const $ = _c(16);
  const {
    alignment,
    heading,
    subheading,
    paragraphText,
    image,
    cta,
    ctaExposures
  } = t0;
  let t1;
  if ($[0] !== image.fields.media) {
    t1 = ContentfulHelper.parseContentfulContentImage(image.fields.media);
    $[0] = image.fields.media;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const contentImage = t1;
  let t2;
  if ($[2] !== paragraphText) {
    t2 = getEntryOfContentType(paragraphText, "prose");
    $[2] = paragraphText;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const prose = t2;
  let t3;
  if ($[4] !== cta) {
    t3 = getEntryOfContentType(cta, "button");
    $[4] = cta;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const ctaButton = t3;
  let t4;
  if ($[6] !== cta) {
    t4 = getEntryOfContentType(cta, "externalButton");
    $[6] = cta;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const ctaExternal = t4;
  const ctaEntry = ctaButton ?? ctaExternal ?? undefined;
  if (!contentImage || !prose) {
    return null;
  }
  let t5;
  if ($[8] !== alignment || $[9] !== contentImage || $[10] !== ctaEntry || $[11] !== ctaExposures || $[12] !== heading || $[13] !== prose || $[14] !== subheading) {
    t5 = <div className="editorial-section px-6 py-6 w-full max-w-site-content mx-auto"><Card className="rounded-md p-6"><CardContent><EditorialSide heading={heading} subheading={subheading} prose={prose} cta={ctaEntry} ctaExposures={ctaExposures} image={contentImage} alignment={alignment} /></CardContent></Card></div>;
    $[8] = alignment;
    $[9] = contentImage;
    $[10] = ctaEntry;
    $[11] = ctaExposures;
    $[12] = heading;
    $[13] = prose;
    $[14] = subheading;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}